export default __webpack_public_path__ + "static/media/material.fd510ed8.svg";